import {
  FSAktivitetstatustypeDto,
  PraksisaktivitetDto,
  PraksisaktivitetStatusDto,
  PraksiskalenderAktivitetDto,
  PraksisklasseDto,
} from '../api/generated/studiested-generated-api';

interface PerInstitution {
  institutionName: string;
  institutionCodesSlug: string;
  institutionNames: string[];
  institutionCodes: string[];
}

export interface PracticeType {
  institutionCodesSlug: string;
  institutionNames: string[];
  institutionCodes: string[];
  emneCode: string;
  emneName: string;
  name: string;
  code: string;
  klasser: PraksisklasseDto[];
}

export interface PracticeTypesPerInstitution extends PerInstitution {
  practiceTypes: PracticeType[];
}

export const practicePeriodColorClass = (
  aktivitet: PraksiskalenderAktivitetDto | PraksisaktivitetDto | null,
): string => {
  if (!aktivitet || !aktivitet.status) {
    return '';
  }

  if (aktivitet.fsStatus !== FSAktivitetstatustypeDto.IngenFeil) {
    return 'agreementWarning';
  }

  switch (aktivitet.status) {
    case PraksisaktivitetStatusDto.ManglerBehov:
      return 'new-missing-need';
    case PraksisaktivitetStatusDto.KanDeles:
    case PraksisaktivitetStatusDto.DeltMedNoenPraksissteder:
      return 'ready-to-share';
    case PraksisaktivitetStatusDto.DeltOgHarKapasitet:
    case PraksisaktivitetStatusDto.VenterPaaOnskeliste:
    case PraksisaktivitetStatusDto.AvsluttetOnskeliste:
      return 'shared-filled-capacity';
    case PraksisaktivitetStatusDto.DeltMenManglerKapasitet:
      return 'shared-missing-capacity';
    case PraksisaktivitetStatusDto.StudenterManglerKlasse:
    case PraksisaktivitetStatusDto.StudenterManglerPlass:
      return 'student-assignment-warning';
    case PraksisaktivitetStatusDto.AlleStudenterFordelt:
    case PraksisaktivitetStatusDto.Aktiv:
    case PraksisaktivitetStatusDto.FordelingsresultatDelt:
      return 'student-assignment-complete';
    case PraksisaktivitetStatusDto.Gjennomfoert:
      return 'published-finished';
    case PraksisaktivitetStatusDto.Avtalefeil:
      return 'agreementWarning';
  }
};

export enum ActivityStatusOptions {
  UNFILTERED = 'unfiltered',
  ALL_ACTIVITIES = 'allActivities',
  ACTIVITIES_NOT_SHARED = 'activitiesNotShared',
  ACTIVITIES_MISSING_NEED = 'activitiesMissingNeed',
  ACTIVITIES_MISSING_CAPACITY = 'activitiesMissingCapacity',
  ACTIVITIES_FILLED_CAPACITY = 'activitiesFilledCapacity',
}
